(() => {
  const STORAGE_KEY = 'clubRetAssessmentV3Progress';
  const RESULT_KEY = 'clubRetAssessmentLatest';
  const SELECT = 'radio';
  const MULTI = 'checkbox';

  const QUESTIONS = {
    current_state:{id:'current_state',kicker:'Let’s start with you',title:'Which sounds most like you right now?',help:'Tretinoin, Retin-A, Tazorac, adapalene, Differin, retinal and retinol are all types of retinoids. You don’t need to know which category yours falls into—we’ll help with that.',type:SELECT,options:[['curious',"I’m thinking about starting but don’t have one yet."],['rx_not_started',"I have a prescription but haven’t started using it."],['new_user',"I recently started using tretinoin, retinol, or another vitamin A product."],['struggling',"I’m using one, but my skin is irritated, peeling, burning, or uncomfortable."],['stable_user',"I use one regularly and my skin is doing pretty well."],['stopped',"I’ve tried one before but stopped using it."],['unsure',"I’m not sure which of these sounds like me."]]},
    goals:{id:'goals',kicker:'What you want for your skin',title:'What would you most like to improve?',help:'Choose everything that matters to you. It’s okay if you have more than one goal.',type:MULTI,options:[['acne','Acne / breakouts'],['aging','Fine lines and signs of aging'],['texture','Rough or uneven texture'],['pigment','Dark spots / uneven skin tone'],['congestion','Clogged pores / congestion'],['longevity','Keeping my skin healthy and looking good long-term'],['unsure','I’m not really sure yet']]},
    baseline:{id:'baseline',kicker:'How your skin feels',title:'How has your skin been feeling lately?',help:'Think about the last week or two—not just how it feels today.',type:SELECT,options:[['comfortable','Pretty comfortable most of the time'],['sometimes_dry','Sometimes dry or tight'],['frequent_dry','Often dry, flaky, or extra sensitive'],['stings','My skincare sometimes stings or burns when I put it on'],['raw','Red, raw, inflamed, or very irritated'],['condition','I have eczema, rosacea, perioral dermatitis, or another diagnosed skin condition'],['unsure','I’m not really sure']]},
    baseline_routine:{id:'baseline_routine',kicker:'What you use',title:"What’s part of your skincare routine right now?",help:"Select everything you use regularly—even if you’re not sure whether it belongs.",type:MULTI,exclusive:['minimal'],options:[['cleanser','Cleanser'],['makeup_remover','Makeup remover / cleansing balm / cleansing oil'],['toner','Toner or essence'],['moisturizer','Moisturizer'],['spf','Sunscreen / SPF'],['hydrating','Hydrating serum / hyaluronic acid'],['vitc','Vitamin C'],['niacinamide','Niacinamide'],['acids','Exfoliating acids such as glycolic, lactic, or salicylic acid'],['bp','Benzoyl peroxide'],['scrubs','Scrub, peel, or exfoliating tool'],['peptides','Peptide products'],['facial_oil','Facial oil'],['masks','Face masks'],['retinoid','Retinol, retinal, tretinoin, or another vitamin A product'],['rx_topical','Another prescription skincare product'],['facials','Regular facials or professional skin treatments'],['multiple','Several treatment serums / active products'],['minimal',"I don’t really have a routine"]]},
    professional_care:{id:'professional_care',kicker:'Professional skincare',title:'Do you currently see an esthetician or skincare professional?',help:'This helps us understand who is already supporting your skin.',type:SELECT,options:[['monthly','Yes — about once a month'],['few_months','Yes — every few months'],['occasional','Occasionally'],['past','I have in the past, but not currently'],['derm_only','I see a dermatologist or medical provider, but not an esthetician'],['none','No']]},
    sunscreen:{id:'sunscreen',kicker:'Sunscreen',title:'How often do you wear sunscreen or SPF on your face?',help:'Choose what you actually do most weeks—there’s no judgment here.',type:SELECT,options:[['daily','Every day'],['most','Most days'],['sometimes','A few days a week'],['rarely','Rarely or never'],['unsure',"I’m not sure whether one of my products contains enough SPF"]]},
    retinoid:{id:'retinoid',kicker:'Your retinoid',title:'What retinoid are you using?',help:'If you are not sure, that is completely okay.',type:SELECT,options:[['tretinoin','Tretinoin'],['tazarotene','Tazarotene'],['adapalene','Adapalene'],['retinal','Retinal / retinaldehyde'],['retinol','Retinol'],['other_rx','Another prescription retinoid'],['other_otc','Another OTC retinoid'],['unknown','I’m not sure']]},
    strength:{id:'strength',kicker:'Prescription details',title:'What strength are you using?',help:'We collect this for context. This assessment will not tell you to change your prescription.',type:SELECT,options:[['001','0.01%'],['0025','0.025%'],['005','0.05%'],['01','0.1%'],['other','Other'],['unknown','I don’t know']]},
    vehicle:{id:'vehicle',kicker:'Prescription details',title:'What formulation are you using?',help:'The vehicle can be part of how a retinoid feels on your skin.',type:SELECT,options:[['cream','Cream'],['gel','Gel'],['lotion','Lotion'],['other','Other'],['unknown','I don’t know']]},
    duration:{id:'duration',kicker:'Your timeline',title:'How long have you been using it?',help:'Choose the closest answer.',type:SELECT,options:[['lt2w','Less than 2 weeks'],['2to4w','2–4 weeks'],['1to2m','1–2 months'],['2to6m','2–6 months'],['6to12m','6–12 months'],['gt1y','More than a year']]},
    frequency:{id:'frequency',kicker:'Consistency',title:'How often are you actually using it?',help:'Not how often you planned to use it—how often it is really making it onto your skin.',type:SELECT,options:[['lt1w','Less than once a week'],['1w','1 night/week'],['2w','2 nights/week'],['third','Every third night'],['alternate','Every other night'],['5to6','5–6 nights/week'],['nightly','Every night'],['variable','It varies constantly']]},
    reactions:{id:'reactions',kicker:'Tolerance',title:'What happens when you use your retinoid?',help:'Select everything you have experienced recently.',type:MULTI,exclusive:['comfortable'],options:[['comfortable','Nothing—my skin feels comfortable'],['mild_dry','Mild dryness'],['light_flake','Occasional light flaking'],['persistent_peel','Persistent peeling'],['tight','Tightness'],['sting','Moisturizer or products sting'],['burn','Burning'],['red','Redness'],['raw','Raw / tender skin'],['breakouts','Increased breakouts'],['rash','Itching / rash'],['dry_eye','Dry or irritated eyes'],['other','Something else']]},
    irritation_area:{id:'irritation_area',kicker:'Tolerance',title:'Where are you noticing irritation?',help:'Select all that apply.',type:MULTI,exclusive:['none'],options:[['nose','Around my nose'],['mouth','Around my mouth'],['eyes','Around my eyes'],['cheeks','Cheeks'],['forehead','Forehead'],['chin','Chin'],['neck','Neck'],['chest','Chest'],['allover','All over'],['none','I don’t have irritation']]},
    application:{id:'application',kicker:'Application',title:'How are you applying it?',help:'Choose what most closely matches your usual routine.',type:SELECT,options:[['damp','After cleansing, while my skin is still damp'],['immediate','Immediately after drying'],['dry','I wait until my skin is completely dry'],['over_moisturizer','Over moisturizer'],['sandwich','Between two layers of moisturizer'],['mixed','I mix it into moisturizer'],['variable','It varies'],['unknown','I’m not sure']]},
    amount:{id:'amount',kicker:'Application',title:'About how much do you use for your face?',help:'Choose the closest answer.',type:SELECT,options:[['less','Less than a pea-sized amount'],['pea','About a pea-sized amount'],['more','More than a pea-sized amount'],['unmeasured','I don’t measure'],['unknown','I have no idea']]},
    actives:{id:'actives',kicker:'Routine load',title:'What else are you using?',help:'Select all that apply.',type:MULTI,exclusive:['none'],options:[['vitc','Vitamin C'],['acids','AHA / BHA / PHA acids'],['toner','Exfoliating toner'],['bp','Benzoyl peroxide'],['scrubs','Scrubs'],['peels','Peels'],['peptides','Peptide products'],['acne','Other acne treatments'],['pigment','Pigmentation treatments'],['rx','Other prescription topical medications'],['none','None—my routine is simple']]},
    results:{id:'results',kicker:'Your results',title:'How would you describe your results so far?',help:'Think about the overall pattern, not a single good or bad skin day.',type:SELECT,options:[['great','Better than expected'],['improving','Definitely improving'],['some','Some improvement, but not enough'],['early','I can’t tell yet'],['none','No noticeable improvement'],['worse','My skin looks worse'],['stopstart','I keep stopping and restarting because of irritation']]},
    success:{id:'success',kicker:'What success looks like',title:'What would make you feel successful?',help:'Choose everything that matters most.',type:MULTI,options:[['clear','Clearer skin'],['smooth','Smoother texture'],['even','More even tone'],['spots','Fewer dark spots'],['aging','Healthier-looking aging'],['less_irritation','Less irritation'],['consistent','Being able to use my retinoid consistently'],['products','Knowing exactly what products to use with it'],['normal','Knowing whether what I’m experiencing is normal'],['guidance','Having someone guide me through the process']]},
    safety:{id:'safety',kicker:'Important safety check',title:'Before we generate your plan, do any of these apply?',help:'This helps us stay inside appropriate educational boundaries.',type:MULTI,exclusive:['none'],options:[['pregnant','Pregnant'],['trying','Trying to become pregnant'],['breastfeeding','Breastfeeding'],['severe','Severe irritation, swelling, blistering, crusting, open skin, or intense pain'],['eczema','History of eczema'],['rosacea','Rosacea'],['pd','Perioral dermatitis'],['dry_eye','Significant dry-eye symptoms'],['rx','Using another prescription skin treatment'],['none','None of these']]}
  };

  const usageStates = new Set(['new_user','struggling','stable_user']);
  const arr=v=>Array.isArray(v)?v:(v?[v]:[]);
  const has=(a,id,v)=>arr(a[id]).includes(v);

  function buildPath(a){
    const p=['current_state']; const state=a.current_state; if(!state)return p;
    if(!usageStates.has(state)){p.push('goals','baseline','baseline_routine','sunscreen','professional_care','success','safety');return p;}
    p.push('retinoid'); if(a.retinoid==='tretinoin')p.push('strength','vehicle');
    p.push('duration','frequency','reactions');
    if(a.reactions && !has(a,'reactions','comfortable'))p.push('irritation_area');
    p.push('application','amount','actives','professional_care','results','success','safety'); return p;
  }

  function classify(a){
    const safety = arr(a.safety);
    const reactions = arr(a.reactions);
    const state = a.current_state;

    /*
      CHECK IN is a safety override, not a journey stage.
    */
    if(
      safety.some(x =>
        ['pregnant','trying','severe','dry_eye'].includes(x)
      )
    ) return 'checkin';

    /*
      RESCUE is a detour caused by meaningful intolerance or repeated
      treatment interruption.
    */
    const meaningfulIrritation = reactions.some(x =>
      ['persistent_peel','sting','burn','red','raw','rash'].includes(x)
    );

    if(
      usageStates.has(state) &&
      (
        meaningfulIrritation ||
        a.results === 'stopstart' ||
        state === 'struggling'
      )
    ) return 'rescue';

    /*
      People who are not currently using a retinoid.
    */
    if(!usageStates.has(state)){
      if(
        ['stings','raw','condition','frequent_dry'].includes(a.baseline) ||
        state === 'stopped'
      ) return 'prep';

      return 'start';
    }

    const tolerating = (
      reactions.length === 0 ||
      reactions.every(x =>
        ['comfortable','mild_dry','light_flake','tight','breakouts','other'].includes(x)
      )
    );

    const earlyDuration = ['lt2w','2to4w','1to2m'].includes(a.duration);
    const establishedDuration = ['2to6m','6to12m','gt1y'].includes(a.duration);

    const lowOrVariableFrequency = [
      'lt1w','1w','2w','third','variable'
    ].includes(a.frequency);

    const consistentFrequency = [
      'alternate','5to6','nightly'
    ].includes(a.frequency);

    /*
      ADAPT = early use, variable use, or still learning tolerance.
    */
    if(
      earlyDuration ||
      lowOrVariableFrequency ||
      !tolerating
    ) return 'adapt';

    /*
      BUILD = tolerating treatment with an established, repeatable rhythm,
      but not yet necessarily at the point where we should call the routine
      fully established.
    */
    if(
      tolerating &&
      establishedDuration &&
      consistentFrequency &&
      ['early','some','improving','none'].includes(a.results)
    ) return 'build';

    /*
      OPTIMIZE = established use + tolerable routine + enough experience
      to evaluate what remains.
    */
    if(
      tolerating &&
      ['6to12m','gt1y'].includes(a.duration) &&
      consistentFrequency &&
      ['great','improving','some','none'].includes(a.results)
    ) return 'optimize';

    return 'adapt';
  }

  function profileLabel(a,stage){
    const activeCount = arr(a.actives).filter(x => x !== 'none').length;

    if(stage === 'checkin') return 'Clinician Check-In';

    if(stage === 'rescue' && activeCount >= 3)
      return 'The Overloaded Routine';

    if(stage === 'rescue')
      return 'The Irritated Stop + Starter';

    if(stage === 'prep' && a.current_state === 'stopped')
      return 'The Restart';

    if(stage === 'prep')
      return 'The Sensitive Starter';

    if(stage === 'start' && a.current_state === 'rx_not_started')
      return 'The Prescription Holder';

    if(stage === 'start')
      return 'The Retinoid-Curious Starter';

    if(
      stage === 'adapt' &&
      (a.frequency === 'variable' || a.results === 'stopstart')
    ) return 'The Stop + Starter';

    if(stage === 'adapt' && activeCount >= 3)
      return 'The Busy Routine';

    if(stage === 'adapt')
      return 'The Early Adapter';

    if(stage === 'build' && activeCount >= 3)
      return 'The Routine Refiner';

    if(stage === 'build')
      return 'The Consistency Builder';

    if(stage === 'optimize')
      return 'The Established User';

    return 'Your Retinoid Profile';
  }

  const PROFILES = {

    prep: {
      badge:'PREP · Get Comfortable First',
      title:"Before you start again, let's make sure your skin is ready.",
      summary:"You're not in the 'use more retinoid' phase yet. Your answers suggest that dryness, sensitivity, irritation, or a previous difficult experience deserves attention before you build a new routine.",
      readiness:'Getting ready',
      score:38,
      priority:'Comfort → Simplify → Prepare',
      priorityCopy:"The goal right now is to understand what is making your skin uncomfortable and create a routine that feels good enough to build on.",
      steps:[
        'Get everyday cleansing and moisturizing comfortable.',
        'Remove unnecessary sources of irritation.',
        'Start or restart only with a routine you understand and can repeat.'
      ],
      timeline:[
        ['NOW','Get your skin feeling comfortable.'],
        ['NEXT','Build a simple starting routine.'],
        ['THEN','Begin your retinoid rhythm when the basics feel manageable.']
      ]
    },

    start: {
      badge:'START · Build Your Routine',
      title:"You're ready to start. Your first goal is not perfect skin.",
      summary:"At this stage, success means understanding what you are using, how it fits into your routine, and what your skin is telling you once you begin.",
      readiness:'Ready to begin',
      score:58,
      priority:'Understand → Start → Repeat',
      priorityCopy:"A good beginning is one you can understand and repeat without constantly wondering whether you are doing it wrong.",
      steps:[
        'Know which vitamin A product you are using and where it fits in your routine.',
        'Keep the rest of the routine understandable.',
        'Pay attention to how your skin responds before adding more complexity.'
      ],
      timeline:[
        ['NOW','Build your starting routine.'],
        ['NEXT','Learn how your skin responds.'],
        ['THEN','Build consistency before chasing intensity.']
      ]
    },

    adapt: {
      badge:'ADAPT · Learning Your Skin',
      title:"You're using it. Now you're learning what your skin can comfortably handle.",
      summary:"This is the adjustment phase. Your skin, schedule, application technique, and the other products in your routine can all affect how easy it is to stay consistent.",
      readiness:'Adjusting',
      score:68,
      priority:'Comfort → Consistency → Learn',
      priorityCopy:"Your biggest win right now is a routine that becomes more predictable from week to week.",
      steps:[
        'Make your current schedule predictable.',
        'Watch for patterns in dryness, peeling, stinging, redness, or breakouts.',
        'Change one meaningful variable at a time.'
      ],
      timeline:[
        ['NOW','Learn what your skin tolerates.'],
        ['NEXT','Make your routine repeatable.'],
        ['THEN','Build consistency once your skin feels predictable.']
      ]
    },

    build: {
      badge:'BUILD · Building Consistency',
      title:"Your skin is handling your routine. Now consistency becomes the work.",
      summary:"You appear to be past the earliest adjustment period and are using your vitamin A product with a reasonably predictable rhythm. This is where staying consistent becomes more important than constantly changing the routine.",
      readiness:'Building',
      score:80,
      priority:'Repeat → Protect → Evaluate',
      priorityCopy:"Keep the parts that are working stable long enough to understand what your treatment is actually doing.",
      steps:[
        'Protect the routine you can already tolerate.',
        'Keep sunscreen and basic skincare consistent.',
        'Give your current routine enough time before deciding what still needs improvement.'
      ],
      timeline:[
        ['NOW','Protect your consistency.'],
        ['NEXT','Watch your results become easier to evaluate.'],
        ['THEN','Decide what, if anything, still needs changing.']
      ]
    },

    rescue: {
      badge:'RESCUE · Get Comfortable Again',
      title:"Your skin is getting uncomfortable enough that it's disrupting your routine.",
      summary:"Your answers point to meaningful irritation, repeated stopping and restarting, or both. This is not the time to measure progress by how much discomfort you can tolerate.",
      readiness:'Needs attention',
      score:30,
      priority:'Stop Guessing → Get Comfortable → Rebuild',
      priorityCopy:"Your first goal is to understand why your skin is uncomfortable enough that you cannot use your routine consistently.",
      steps:[
        'Treat persistent burning, rawness, redness, stinging, or peeling as useful information.',
        'Look at your whole routine—not just your retinoid.',
        'Rebuild consistency after your skin is comfortable again.'
      ],
      timeline:[
        ['NOW','Get your skin comfortable again.'],
        ['NEXT','Identify what was getting in the way.'],
        ['THEN','Return to a routine you can actually sustain.']
      ]
    },

    optimize: {
      badge:'OPTIMIZE · Established Routine',
      title:"You've built a routine your skin can handle.",
      summary:"You have enough consistent experience now to evaluate what your retinoid is doing and decide whether any remaining concerns actually need another intervention.",
      readiness:'Established',
      score:92,
      priority:'Protect → Evaluate → Refine',
      priorityCopy:"More skincare is not automatically better. At this stage, every additional product or treatment should have a clear reason to be there.",
      steps:[
        'Keep your successful retinoid routine stable.',
        'Evaluate your remaining goals one at a time.',
        'Only add something new when it solves a specific problem.'
      ],
      timeline:[
        ['NOW','Protect what is already working.'],
        ['NEXT','Identify what still matters to you.'],
        ['THEN','Refine without destabilizing your routine.']
      ]
    },

    checkin: {
      badge:'CHECK IN · Medical Guidance First',
      title:"One of your answers needs your medical provider first.",
      summary:"Something in your assessment falls outside what an online skincare assessment or esthetic consultation should try to interpret.",
      readiness:'Medical guidance first',
      score:20,
      priority:'Clarify → Then Continue',
      priorityCopy:"Get the appropriate medical guidance first. Club Ret can help with the day-to-day skincare side once that question has been addressed.",
      steps:[
        'Do not change prescription treatment based on this assessment.',
        'Write down the symptoms, products, and medications involved.',
        'Contact the appropriate licensed healthcare professional.'
      ],
      timeline:[
        ['NOW','Clarify the medical question.'],
        ['NEXT','Follow your clinician’s guidance.'],
        ['THEN','Return to Club Ret for skincare routine support.']
      ],
      safety:"This result does not diagnose what is happening. Pregnancy or trying to conceive, severe skin reactions, significant eye symptoms, and other medical concerns need individualized guidance from an appropriate licensed healthcare professional."
    }

  };

  class Assessment{
    constructor(root){this.root=root;this.state={started:false,completed:false,index:0,path:['current_state'],answers:{}};this.config=this.readConfig();this.cache();this.restore();this.syncPath();this.bind();this.renderInitial()}
    readConfig(){try{return JSON.parse(this.root.querySelector('[data-cr-config]').textContent)}catch(e){return{}}}
    cache(){this.stage=this.root.querySelector('[data-cr-stage]');this.intro=this.root.querySelector('[data-cr-intro]');this.question=this.root.querySelector('[data-cr-question]');this.results=this.root.querySelector('[data-cr-results]');this.progress=this.root.querySelector('[data-cr-progress]');this.form=this.root.querySelector('[data-cr-form]');this.options=this.root.querySelector('[data-cr-options]');this.error=this.root.querySelector('[data-cr-error]');this.back=this.root.querySelector('[data-cr-back]');this.saveStatus=this.root.querySelector('[data-cr-save-status]');this.dialog=this.root.querySelector('[data-cr-exit-dialog]')}
    restore(){try{const fresh=new URLSearchParams(location.search).get('start')==='1';if(fresh){localStorage.removeItem(STORAGE_KEY);sessionStorage.removeItem(RESULT_KEY);this.state={started:false,completed:false,index:0,path:['current_state'],answers:{}};return}const s=JSON.parse(localStorage.getItem(STORAGE_KEY));if(s&&s.started&&!s.completed)this.state={...this.state,...s};else if(s)localStorage.removeItem(STORAGE_KEY)}catch(e){localStorage.removeItem(STORAGE_KEY)}}
    syncPath(){this.state.path=buildPath(this.state.answers);if(this.state.index>=this.state.path.length)this.state.index=this.state.path.length-1}
    save(){if(this.state.completed)localStorage.removeItem(STORAGE_KEY);else localStorage.setItem(STORAGE_KEY,JSON.stringify(this.state));this.saveStatus.textContent='Progress saved';clearTimeout(this.saveStatus.t);this.saveStatus.t=setTimeout(()=>this.saveStatus.textContent='Progress saves automatically',1200)}
    bind(){this.root.querySelector('[data-cr-start]').addEventListener('click',()=>{sessionStorage.removeItem(RESULT_KEY);this.state.started=true;this.state.completed=false;this.state.index=0;this.state.answers={};this.syncPath();this.save();this.showQuestion()});this.form.addEventListener('submit',e=>this.submit(e));this.back.addEventListener('click',()=>this.goBack());this.root.querySelector('[data-cr-restart]').addEventListener('click',()=>this.restart());this.root.querySelector('[data-cr-exit]').addEventListener('click',()=>this.dialog.showModal?this.dialog.showModal():location.assign('/'))}
    renderInitial(){const fresh=new URLSearchParams(location.search).get('start')==='1';if(fresh){this.state.started=true;this.state.completed=false;this.state.index=0;this.state.answers={};this.syncPath();this.save();this.showQuestion();return}if(this.state.started)this.showQuestion()}
    showQuestion(){this.intro.hidden=true;this.results.hidden=true;this.question.hidden=false;this.progress.hidden=false;this.renderQuestion()}
    renderQuestion(){this.syncPath();const id=this.state.path[this.state.index],q=QUESTIONS[id];this.root.querySelector('[data-cr-question-kicker]').textContent=q.kicker;this.root.querySelector('[data-cr-question-title]').textContent=q.title;this.root.querySelector('[data-cr-question-help]').textContent=q.help||'';this.root.querySelector('[data-cr-question-legend]').textContent=q.title;this.error.hidden=true;this.back.hidden=this.state.index===0;this.options.innerHTML='';const current=arr(this.state.answers[q.id]);q.options.forEach(([value,text])=>{const label=document.createElement('label');label.className='cr-option'+(current.includes(value)?' is-selected':'');label.dataset.type=q.type;label.innerHTML=`<input type="${q.type}" name="${q.id}" value="${value}" ${current.includes(value)?'checked':''}><span class="cr-option__control"></span><span class="cr-option__label"></span>`;label.querySelector('.cr-option__label').textContent=text;const input=label.querySelector('input');input.addEventListener('change',()=>this.change(q,value,input,label));this.options.appendChild(label)});const pct=Math.round(((this.state.index+1)/this.state.path.length)*100);this.root.querySelector('[data-cr-progress-label]').textContent=`Question ${this.state.index+1} of ${this.state.path.length}`;this.root.querySelector('[data-cr-progress-percent]').textContent=`${pct}%`;this.root.querySelector('[data-cr-progress-fill]').style.width=`${pct}%`;this.root.querySelector('[data-cr-progress-track]').setAttribute('aria-valuenow',pct);this.animate();scrollTo({top:Math.max(this.root.offsetTop-20,0),behavior:'smooth'})}
    change(q,value,input,label){this.error.hidden=true;if(q.type===SELECT){this.state.answers[q.id]=value;this.options.querySelectorAll('.cr-option').forEach(x=>x.classList.remove('is-selected'));label.classList.add('is-selected')}else{let next=arr(this.state.answers[q.id]);const exclusive=q.exclusive||[];if(exclusive.includes(value)){next=[value];this.options.querySelectorAll('input').forEach(x=>{x.checked=x.value===value;x.closest('.cr-option').classList.toggle('is-selected',x.value===value)})}else{next=next.filter(x=>!exclusive.includes(x));next=input.checked?[...new Set([...next,value])]:next.filter(x=>x!==value);label.classList.toggle('is-selected',input.checked);exclusive.forEach(v=>{const x=this.options.querySelector(`input[value="${v}"]`);if(x){x.checked=false;x.closest('.cr-option').classList.remove('is-selected')}})}this.state.answers[q.id]=next}this.syncPath();this.save()}
    submit(e){e.preventDefault();this.syncPath();const q=QUESTIONS[this.state.path[this.state.index]],a=this.state.answers[q.id],valid=Array.isArray(a)?a.length:Boolean(a);if(!valid){this.error.textContent='Choose an answer to continue.';this.error.hidden=false;return}this.syncPath();if(this.state.index<this.state.path.length-1){this.state.index++;this.save();this.renderQuestion()}else{this.state.completed=true;this.save();this.showResults()}}
    goBack(){if(this.state.index>0){this.state.index--;this.save();this.renderQuestion()}}
    showResults(){
      const stage=classify(this.state.answers);
      const profile=profileLabel(this.state.answers,stage);

      try{
        sessionStorage.setItem(
          RESULT_KEY,
          JSON.stringify({
            version:3.1,
            stage,
            profile,
            answers:this.state.answers,
            completedAt:new Date().toISOString()
          })
        );
      }catch(e){}

      const url=new URL(
        this.config.membershipUrl || '/pages/my-retinoid-plan',
        location.origin
      );

      url.searchParams.set('stage',stage);
      url.searchParams.set('profile',profile);

      location.assign(url.pathname + url.search);
    }
    restart(){localStorage.removeItem(STORAGE_KEY);sessionStorage.removeItem(RESULT_KEY);this.state={started:true,completed:false,index:0,path:['current_state'],answers:{}};this.showQuestion()}
    animate(){this.stage.classList.remove('is-entering');requestAnimationFrame(()=>this.stage.classList.add('is-entering'))}
    escape(v){const d=document.createElement('div');d.textContent=v;return d.innerHTML}
  }

  const boot=()=>document.querySelectorAll('[data-cr-assessment]').forEach(root=>{if(!root.dataset.crReady){root.dataset.crReady='true';new Assessment(root)}});
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();
  document.addEventListener('shopify:section:load',boot);
})();
